import * as React from "preact";
import { FunctionComponent } from "preact";
import { useEffect, useState } from "preact/hooks";

import cx from "classnames";

import CashHubCard from "./components/CashHubCard";
import ErrorAlert from "../components/ErrorAlert";

interface IAppProps {
  apiUrl: string;
  easyAccessLabel: string;
  noticeAccountLabel: string;
  fixedRateBondLabel: string;
  errorTitleLabel: string;
  errorMessageLabel: string;
  cashhubClientType: string;
}

const App: FunctionComponent<IAppProps> = ({
  apiUrl,
  easyAccessLabel,
  noticeAccountLabel,
  fixedRateBondLabel,
  errorTitleLabel,
  errorMessageLabel,
  cashhubClientType,
}) => {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<boolean>(false);
  const [firstRun, setFirstRun] = useState<boolean>(false);
  const [clientType] = useState<string>(cashhubClientType);

  useEffect(() => {
    if (apiUrl) {
      if (!firstRun) {
        fetchResults();
      }
    }
  }, []);

  const getCurrentRateDetails = (details: any): any => {
    const now = new Date();
    let rate = null;
    if (details.startDate != null) {
      rate = details.rateDetails.find((el) => {
        return new Date(el.startDate) >= now;
      });
    } else {
      rate = details.rateDetails.find((el) => {
        return new Date(el.startDate) <= now && new Date(el.endDate) > now;
      });
      if (rate == null) {
        return details.rateDetails.find((el) => {
          return new Date(el.startDate) <= now && el.endDate == null;
        });
      }
    }
    return rate;
  };

  const processData = (): any => {
    let filteredData = new Array();
    if (clientType) {
      const filterList = clientType.split(",");
      data.content.forEach(item => {
        if (filterList.some(type => item.accountHolderTypes.includes(type))) {
          filteredData.push(item);
        }
      });
    } else {
      filteredData = data.content;
    }

    const availableProducts = filteredData.filter((x) => {
      return (
        new Date(x.productAvailability.availableFrom) <= new Date() &&
        (x.productAvailability.availableUntil == null || new Date(x.productAvailability.availableUntil) >= new Date())
      );
    });

    const rateFilteredData = availableProducts.filter((x) => {
      return getCurrentRateDetails(x) != undefined;
    });
    return Object.values(
      rateFilteredData.reduce(function (r, e) {
        if (!r[e.productType] || (getCurrentRateDetails(e).aerRate > getCurrentRateDetails(r[e.productType]).aerRate)) {
          r[e.productType] = e;
        }
        return r;
      }, {})
    );
  };

  const fetchResults = (): Promise<void> => {
    return fetch(apiUrl)
      .then(function (res) {
        if (res.status != 200) {
          setError(true);
          return;
        }
        res
          .json()
          .then(function (data) {
            setData(data);
            setFirstRun(true);
          })
          .catch((err) => {
            logError(err);
          });
      })
      .catch((err) => {
        logError(err);
      });
  };

  const logError = (err) => {
    setData(null);
    setError(true);
    console.log(err);
  };

  const sortProcessData = (a, b) => {
    if (a.productType > b.productType) return 1;
    if (b.productType > a.productType) return -1;
    return 0;
  }

  return (
    <div className={cx({ cardholder__row: !error })}>
      {error && (
        <ErrorAlert
          title={errorTitleLabel}
          message={errorMessageLabel}
        ></ErrorAlert>
      )}
      {data &&
        processData()
          .sort(sortProcessData)
          .map((item) => {
            const rate = getCurrentRateDetails(item);
            const convertedRate = rate.aerRate * 100;
            return (
              <CashHubCard
                rate={convertedRate.toFixed(2)}
                notice={item.periodFeature.noticePeriod}
                term={item.periodFeature.termPeriod}
                productType={item.productType}
                easyAccessLabel={easyAccessLabel}
                fixedRateBondLabel={fixedRateBondLabel}
                noticeAccountLabel={noticeAccountLabel}
              ></CashHubCard>
            );
          })}
    </div>
  );
};

export default App;
